// @ts-nocheck


export const Features = {
  Warehouses: 'warehouses',
  Branches: 'branches',
  ManualJournal: 'manualJournal',
  Projects:'Projects',
  BankSyncing: 'BankSyncing',
}